import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { FDPaper } from '@facet-wealth/design';
import React from 'react';

const useStyles = buildUseStyles('RaisedPaper', (theme) => ({
  shadow: {
    boxShadow: '0px 3px 10px 0px rgba(0, 0, 0, 0.08)', // Matches the boxShadow that FDPaper has when appearance=elevated
    borderRadius: theme.spacing(2), // Matches the border radius for FDPaper
  },
}));

// This a workaround because we need an FDPaper with both box shadow *and* a colored outline for
// this one-off design. I am not convinced that this component has been thoroughly considered enough to put in
// the DS or even become an Experimental component. I have concerns that it makes non-clickable objects
// look too much like buttons and I think the darker blue and green borders look pretty funny with drop shadows
// for larger FDPapers.
export const RaisedPaper = (props) => {
  const { children, ...restProps } = props;
  const theme = useTheme();
  const classes = useStyles(theme);
  return (
    <div className={classes.shadow}>
      <FDPaper
        {...restProps}
        appearance={'outlined'}
      >
        {children}
      </FDPaper>
    </div>
  );
};
